import React from "react";

const Icon = ({ width = 99, height = 98, }) => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={`${width}px`} height={`${height}px`} viewBox="0 0 99 98">
      <title>Canada Post</title>
      <path fill="#D92C27" d="M92.807,48.584c0,23.694-19.196,42.903-42.924,42.903c-23.693,0-42.898-19.209-42.898-42.903  c0-23.715,19.205-42.918,42.898-42.918C73.61,5.666,92.807,24.869,92.807,48.584z"></path>
      <g>
        <polygon fill="#FFFFFF" points="36.293,54.172 39.335,51.131 73.333,49.602 74.854,48.085 41.357,48.085 23.09,26.75    83.985,47.063 63.696,67.378 23.09,67.378 27.159,63.304 61.146,61.79 62.651,60.261 30.191,60.261 33.243,57.208 67.239,55.688    68.762,54.172"></polygon>
      </g>
    </svg>
  );
};

export default Icon;
